var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28713",
    "data-name": "Rectangle 28713",
    width: 400,
    height: 400,
    transform: "translate(278.5)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_52084",
    "data-name": "Mask Group 52084",
    transform: "translate(-278.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "question-2",
    "data-name": "question",
    d: "M8.736-163.8H58.968c0-14.352,8.424-23.712,23.712-23.712,13.728,0,22.464,8.736,22.464,22.776.312,22.776-19.968,28.08-49.3,28.08H37.128l1.56,58.032h46.8l1.56-23.4c40.872-.312,69.888-22.152,69.888-62.4,0-43.368-30.264-66.768-73.632-66.768C34.008-231.192,7.8-201.24,8.736-163.8ZM94.224-26.208c0-16.536-12.792-29.328-31.512-29.328-19.032,0-31.824,12.792-31.824,29.328C30.888-10.3,43.68,2.5,62.712,2.5,81.432,2.5,94.224-10.3,94.224-26.208Z",
    transform: "translate(395.676 314.348)",
    fill: "#87a1b5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9774b6bd82ed0cf99f3e8c6b88b8d624.svg";
export { ForwardRef as ReactComponent };